import { render, staticRenderFns } from "./Multilingual.vue?vue&type=template&id=25b10c89&"
import script from "./Multilingual.vue?vue&type=script&lang=js&"
export * from "./Multilingual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports